// TTL de 5 minutos. Después de este tiempo los catálogos se consideran desactualizados.
const CATALOG_TTL_MS = 5 * 60 * 1000

const STORAGE_KEY = 'global_catalog_cache_timestamps'

// Capa 1: RAM. Más rápida que leer localStorage en cada verificación.
const _memoryCache = new Map<string, number>()

function _readStoredTimestamps(): Record<string, number> {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        return raw ? JSON.parse(raw) : {}
    } catch {
        return {}
    }
}

/**
 * Verifica si un catálogo fue cargado recientemente y sigue vigente.
 * Busca primero en RAM y luego en localStorage.
 *
 * Siempre úsala junto con una verificación de datos:
 *   if (storedData && catalogIsFresh('clave')) return
 */
export function catalogIsFresh(key: string): boolean {
    let lastFetchedAt = _memoryCache.get(key)

    if (lastFetchedAt === undefined) {
        const stored = _readStoredTimestamps()
        lastFetchedAt = stored[key]
        if (lastFetchedAt !== undefined) {
            _memoryCache.set(key, lastFetchedAt)
        }
    }

    if (lastFetchedAt === undefined) return false
    return Date.now() - lastFetchedAt < CATALOG_TTL_MS
}

/**
 * Limpia entradas corruptas de localStorage (valor "undefined" o "null" como string).
 * Llama a esto una sola vez al arrancar la app.
 */
export function catalogSanitizeStorage(keys: string[]): void {
    // localStorage puede lanzar (NS_ERROR_FAILURE en Firefox con protección
    // anti-rastreo estricta, modo privado, storage lleno). Al correr en el
    // arranque, un throw aquí tumbaba el bootstrap completo — se blinda igual
    // que _readStoredTimestamps.
    try {
        for (const key of keys) {
            const raw = localStorage.getItem(key)
            if (raw === 'undefined' || raw === 'null') {
                localStorage.removeItem(key)
            }
        }
    } catch {
        // storage no disponible — no hay nada que sanear, la app sigue montando
    }
}

/**
 * Registra que un catálogo se cargó exitosamente.
 * Llama a esta función justo después de guardar los datos en localStorage.
 */
export function catalogTouch(key: string): void {
    const now = Date.now()
    _memoryCache.set(key, now)
    try {
        const stored = _readStoredTimestamps()
        stored[key] = now
        localStorage.setItem(STORAGE_KEY, JSON.stringify(stored))
    } catch {
        // localStorage lleno o no disponible — la capa RAM sigue funcionando
    }
}
